module.exports = __webpack_public_path__ + "img/pink.a26f9641.svg";